import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {EnhanceImagesParams} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {type UpscaleImageParams, fetchEnhancedImages} from './requests'
import {ERRORS} from '../constants'

export const enhanceImages = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, userRequestInfo, onSuccess, onError}: EnhanceImagesParams
): Promise<void> => {
    return generateAndInjectImages<UpscaleImageParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url) => ({
            imageUrl: url
        }),
        fetchEnhancedImages,
        {userRequestInfo, onSuccess, onError, caller: 'enhanceImages', errorType: ERRORS.IMAGES.ENHANCE_IMAGES}
    )
}
